import { NavLink } from "react-router-dom";
import { Home, Search, Bookmark, Newspaper, MessageSquare } from "lucide-react";
import { TID } from "@/lib/constants";

const tabs = [
  { to: "/", label: "Feed", icon: Home, testId: "bottom-tab-feed" },
  { to: "/search", label: "Search", icon: Search, testId: "bottom-tab-search" },
  { to: "/saved", label: "Saved", icon: Bookmark, testId: "bottom-tab-saved" },
  { to: "/gazette", label: "Gazette", icon: Newspaper, testId: "bottom-tab-gazette" },
  { to: "/zero-hour", label: "Zero Hour", icon: MessageSquare, testId: "bottom-tab-zero-hour" },
];

export default function BottomTabBar({ gazetteUnread = false }) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30" aria-label="Primary">
      <div className="mx-auto w-full max-w-[760px] bg-[#111622]/95 backdrop-blur border-t border-[#1A2232]">
        <ul className="grid grid-cols-5 px-2 py-2" style={{ paddingBottom: "calc(0.5rem + env(safe-area-inset-bottom))" }}>
          {tabs.map(({ to, label, icon: Icon, testId }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={to === "/"}
                className={({ isActive }) => `relative flex flex-col items-center justify-center gap-1 rounded-xl py-2 text-xs font-semibold ${isActive ? "text-[#E85A2A]" : "text-[#64748B] hover:text-[#F8FAFC] hover:bg-[#1A2232]"} transition-colors`}
                data-testid={testId}
              >
                <Icon className="h-5 w-5" aria-hidden />
                <span className="leading-none">{label}</span>
                {to === "/gazette" && gazetteUnread && (
                  <span
                    data-testid={TID.gazetteDot}
                    aria-label="New gazette items"
                    className="absolute right-3 top-1 h-2 w-2 rounded-full bg-[#F2BD68] dot-pulse"
                  />
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
